function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.72667 9.00665L10.28 11.66M10.2733 4.33998L5.72667 6.99331M14 3.33331C14 4.43788 13.1046 5.33331 12 5.33331C10.8954 5.33331 10 4.43788 10 3.33331C10 2.22874 10.8954 1.33331 12 1.33331C13.1046 1.33331 14 2.22874 14 3.33331ZM6 7.99998C6 9.10455 5.10457 9.99998 4 9.99998C2.89543 9.99998 2 9.10455 2 7.99998C2 6.89541 2.89543 5.99998 4 5.99998C5.10457 5.99998 6 6.89541 6 7.99998ZM14 12.6666C14 13.7712 13.1046 14.6666 12 14.6666C10.8954 14.6666 10 13.7712 10 12.6666C10 11.5621 10.8954 10.6666 12 10.6666C13.1046 10.6666 14 11.5621 14 12.6666Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.38b43dcf.svg";
export { ForwardRef as ReactComponent };